import { type FC, type ReactNode, useEffect, useRef } from "react";
import { initAutoUpdate } from "../utils/version";

interface PWAUpdateHandlerProps {
  children: ReactNode;
}

const PWAUpdateHandler: FC<PWAUpdateHandlerProps> = ({ children }) => {
  const isInitializedRef = useRef(false);

  useEffect(() => {
    if (isInitializedRef.current) return;
    isInitializedRef.current = true;

    const { cleanup } = initAutoUpdate();
    return cleanup;
  }, []);

  return <>{children}</>;
};

export default PWAUpdateHandler;
